import { Injectable } from '@angular/core';
import { Adapter } from '../adapter.service';
import { Auth } from '../../../models/auth.model';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationAdapterService implements Adapter<Auth> {
  public adapt(item: any): Auth {
    return {
      refreshToken: item.refreshToken,
      idDataKlinik: item.idDataKlinik,
      token: item.accessToken || item.token,
      _embedded: item['_embedded'],
    } as Auth;
  }
}
